import { useCallback } from 'react';

import { useSelector } from 'react-redux';

import {
    selectAppSessionId,
    selectVideoSessionId,
} from 'store/session/selectors';

import { RailViewUavParams, UavEvents } from './types';
import useGetBaseUavParams from './useGetBaseUavParams';

export default function useGetRailViewParams() {
    const appSessionId = useSelector(selectAppSessionId);
    const genericVideoSessionId = useSelector(selectVideoSessionId);

    const getBaseUavParams = useGetBaseUavParams();

    const getRailViewParams = useCallback(
        (
            templateId: string,
            railId: string,
            depth: number,
        ): RailViewUavParams | undefined => {
            const baseUavParams = getBaseUavParams(UavEvents.RAIL_VIEW);

            if (baseUavParams) {
                return {
                    ...baseUavParams,
                    metadata: {
                        railId,
                        templateId,
                        appSessionId,
                        depth: `${depth + 1}`,
                        playbackSessionId: genericVideoSessionId,
                        ...baseUavParams.metadata,
                    },
                };
            }

            return undefined;
        },
        [getBaseUavParams, appSessionId, genericVideoSessionId],
    );

    return {
        getRailViewParams,
    };
}
